export default "__VITE_ASSET__DfK15HE8__"